<section>
  <div class="container-fluid py-4 px-4">

    <div class="container-fluid container-card mb-4">
      <h1 class="heading-1">Hotel Statistics</h1>

      <div class="row">
        <div class="col-12 col-md-12 col-lg-3 my-2 my-lg-0">
          <div class="card card-custom mb-2" *ngFor="let item of totalGuestItem">
            <div class="card-body card-body-custom">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/Hotel.png"> {{ item.name }}
              </h5>
              <p class="card-text text-center text-count">{{ item.total | thousandSeparator }}</p>  <!--TW20250924-->
            </div>
          </div>
        </div>

        <div class="col-12 col-md-12 col-lg-4 my-2 my-lg-0">

          <div class="card card-occupancy">
            <div class="card-body card-body-custom">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/user.png"> Occupancy
              </h5>

              <div *ngIf="!isLoading && occupancyItem.length > 0">
                <div class="container-fluid container-box-progress" *ngFor="let item of occupancyItem">
                  <div class="row">
                    <!-- Header dengan master toggle -->
                    <div class="row header-row" (click)="toggleTotal()" style="cursor: pointer;">
                      <div class="col-5 title-text">
                        {{ item.name }}
                        <i class="fas ms-2" [class.fa-chevron-down]="!isTotalExpanded" [class.fa-chevron-up]="isTotalExpanded"></i>
                      </div>
                      <div class="col-7 total-text">{{ item.total }}%</div>
                    </div>

                    <!-- Budget Section (selalu tampil) -->
                    <div class="metric-group">
                      <div class="remarks-text">{{ item.remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(item.from_budget)">
                          {{ item.from_budget }}%
                        </span>
                        <span class="value-text">{{ item.budget }}%</span>
                      </div>
                    </div>
                    
                    <!-- Expandable Sections (hanya tampil jika Total di-expand) -->
                    <div *ngIf="isTotalExpanded">
                      <!-- Last Month Section -->
                      <div class="metric-group">
                        <div class="remarks-text">{{ item.lm_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.pct_lm)">
                            {{ item.pct_lm }}%
                          </span>
                          <span class="value-text">{{ item.last_month}}%</span>
                        </div>
                      </div>

                      <!-- Last Year Section -->
                      <div class="metric-group">
                        <div class="remarks-text">{{ item.ly_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.pct_ly)">
                            {{ item.pct_ly }}%
                          </span>
                          <span class="value-text">{{ item.last_year}}%</span>
                        </div>
                      </div>

                      <!-- This Year Section -->
                      <!--<div class="metric-group last-group">
                        <div class="remarks-text">{{ item.ty_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.pct_ty)">
                            {{ item.pct_ty }}%
                          </span>
                          <span class="value-text">{{ item.this_year}}%</span>
                        </div>
                      </div>-->
                    </div>  
                  </div>
                </div>
              </div>

              <div class="container-box d-flex justify-content-center" *ngIf="!isLoading && occupancyItem.length === 0">
                <div class="spinner-border text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="col-12 col-md-12 col-lg-5 mb-4 mb-lg-0">
          <div class="card card-revenue">
            <div class="card-body card-body-custom">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/revenue.png"> Revenue
              </h5>

              <div *ngIf="!isLoading && revenueItem.length > 0">
  
                <!-- TOTAL SECTION (Modified) -->
                <div class="container-fluid container-box-progress" *ngFor="let item of totalRevenueOnly">
                  <div class="row">
                    <!-- Header dengan master toggle -->
                    <div class="row header-row" (click)="toggleTotal()" style="cursor: pointer;">
                      <div class="col-5 title-text">
                        {{ item.name }}
                        <i class="fas ms-2" [class.fa-chevron-down]="!isTotalExpanded" [class.fa-chevron-up]="isTotalExpanded"></i>
                      </div>
                      <div class="col-7 total-text">{{ item.total | rupiah }}</div>
                    </div>

                    <!-- Budget Section (selalu tampil) -->
                    <div class="metric-group">
                      <div class="remarks-text">{{ item.remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(item.percentage)">
                          {{ item.percentage }}%
                        </span>
                        <span class="value-text">{{ item.budget | rupiah }}</span>
                      </div>
                    </div>
                    
                    <!-- Expandable Sections (hanya tampil jika Total di-expand) -->
                    <div *ngIf="isTotalExpanded">
                      <!-- Last Month Section -->
                      <div class="metric-group">
                        <div class="remarks-text">{{ item.lm_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.lm_percentage)">
                            {{ item.lm_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_month | rupiah }}</span>
                        </div>
                      </div>

                      <!-- Last Year Section -->
                      <div class="metric-group">
                        <div class="remarks-text">{{ item.ly_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.ly_percentage)">
                            {{ item.ly_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_year | rupiah }}</span>
                        </div>
                      </div>

                      <!-- This Year Section -->
                      <div class="metric-group last-group">
                        <div class="remarks-text">{{ item.ty_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="value-text">{{ item.total_ytd| rupiah }}</span>
                          <span class="percentage-text" [class]="getPercentageClass(item.ty_percentage)">
                            {{ item.ty_percentage }}%
                          </span>
                          <span class="value-text">{{ item.this_year | rupiah }}</span>
                        </div>
                      </div>
                    </div>  
                  </div>
                </div>
                
                <!-- Room Section (dengan icon) -->
                <div class="mb-3 revenue-item-card" *ngFor="let item of revenueItem; let i = index">
                  <div *ngIf="item.name === 'Room'">
                    <div class="row header-row" (click)="toggleExpand(i)" style="cursor: pointer;">
                      <div class="col-5 title-text">
                        {{ item.name }}
                        <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[i]" [class.fa-chevron-up]="expandedStates[i]"></i>
                      </div>
                      <div class="col-7 total-text">{{ item.total | rupiah }}</div>
                    </div>

                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(item.percentage)">
                          {{ item.percentage }}%
                        </span>
                        <span class="value-text">{{ item.budget | rupiah }}</span>
                      </div>
                    </div>
                    
                    <div *ngIf="expandedStates[i]">
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.lm_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.lm_percentage)">
                            {{ item.lm_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_month | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ly_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.ly_percentage)">
                            {{ item.ly_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_year | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group last-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ty_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="value-text">{{ item.total_ytd | rupiah }}</span>
                          <span class="percentage-text" [class]="getPercentageClass(item.ty_percentage)">
                            {{ item.ty_percentage }}%
                          </span>
                          <span class="value-text">{{ item.this_year | rupiah }}</span>
                        </div>
                      </div>
                    </div>  
                  </div>
                </div>

                <!-- Horizontal Line Separator -->
                <hr class="my-3" style="border-top: 1px solid #dee2e6;">

                <!-- F&B Section -->
                <div class="mb-3 revenue-item-card" *ngFor="let item of revenueItem; let i = index">
                  <div *ngIf="item.name === 'F&B'">
                    <div class="row header-row" (click)="toggleExpand(i)" style="cursor: pointer;">
                      <div class="col-5 title-text">
                        {{ item.name }}
                        <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[i]" [class.fa-chevron-up]="expandedStates[i]"></i>
                      </div>
                      <div class="col-7 total-text">{{ item.total | rupiah }}</div>
                    </div>

                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(item.percentage)">
                          {{ item.percentage }}%
                        </span>
                        <span class="value-text">{{ item.budget | rupiah }}</span>
                      </div>
                    </div>

                    <div *ngIf="expandedStates[i]">
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.lm_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.lm_percentage)">
                            {{ item.lm_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_month | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ly_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.ly_percentage)">
                            {{ item.ly_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_year | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group last-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ty_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="value-text">{{ item.total_ytd | rupiah }}</span>
                          <span class="percentage-text" [class]="getPercentageClass(item.ty_percentage)">
                            {{ item.ty_percentage }}%
                          </span>
                          <span class="value-text">{{ item.this_year | rupiah }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- F&B Sub-items - Restaurant -->
                <div class="mb-3 revenue-item-card" *ngFor="let item of revenueItem; let i = index" style="padding-left: 20px;">
                  <div *ngIf="item.name === 'F&B - Restaurant'">
                    <div class="row header-row" (click)="toggleExpand(i)" style="cursor: pointer;">
                      <div class="col-5 title-text">
                        {{ item.name }}
                        <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[i]" [class.fa-chevron-up]="expandedStates[i]"></i>
                      </div>
                      <div class="col-7 total-text">{{ item.total | rupiah }}</div>
                    </div>

                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(item.percentage)">
                          {{ item.percentage }}%
                        </span>
                        <span class="value-text">{{ item.budget | rupiah }}</span>
                      </div>
                    </div>
                    
                    <div *ngIf="expandedStates[i]">
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.lm_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.lm_percentage)">
                            {{ item.lm_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_month | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ly_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.ly_percentage)">
                            {{ item.ly_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_year | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group last-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ty_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="value-text">{{ item.total_ytd | rupiah }}</span>
                          <span class="percentage-text" [class]="getPercentageClass(item.ty_percentage)">
                            {{ item.ty_percentage }}%
                          </span>
                          <span class="value-text">{{ item.this_year | rupiah }}</span>
                        </div>
                      </div>
                    </div>  
                  </div>
                </div>

                <!-- F&B Sub-items - MICE -->
                <div class="mb-3 revenue-item-card" *ngFor="let item of revenueItem; let i = index" style="padding-left: 20px;">
                  <div *ngIf="item.name === 'F&B - Mice'">
                    <div class="row header-row" (click)="toggleExpand(i)" style="cursor: pointer;">
                      <div class="col-5 title-text">
                        {{ item.name }}
                        <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[i]" [class.fa-chevron-up]="expandedStates[i]"></i>
                      </div>
                      <div class="col-7 total-text">{{ item.total | rupiah }}</div>
                    </div>

                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(item.percentage)">
                          {{ item.percentage }}%
                        </span>
                        <span class="value-text">{{ item.budget | rupiah }}</span>
                      </div>
                    </div>

                    <div *ngIf="expandedStates[i]">
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.lm_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.lm_percentage)">
                            {{ item.lm_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_month | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ly_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.ly_percentage)">
                            {{ item.ly_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_year | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group last-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ty_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="value-text">{{ item.total_ytd | rupiah }}</span>
                          <span class="percentage-text" [class]="getPercentageClass(item.ty_percentage)">
                            {{ item.ty_percentage }}%
                          </span>
                          <span class="value-text">{{ item.this_year | rupiah }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Horizontal Line Separator -->
                <hr class="my-3" style="border-top: 1px solid #dee2e6;">

                <!-- Other Section -->
                <div class="mb-3 revenue-item-card" *ngFor="let item of revenueItem; let i = index">
                  <div *ngIf="item.name === 'Other'">
                    <div class="row header-row" (click)="toggleExpand(i)" style="cursor: pointer;">
                      <div class="col-5 title-text">
                        {{ item.name }}
                        <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[i]" [class.fa-chevron-up]="expandedStates[i]"></i>
                      </div>
                      <div class="col-7 total-text">{{ item.total | rupiah }}</div>
                    </div>

                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(item.percentage)">
                          {{ item.percentage }}%
                        </span>
                        <span class="value-text">{{ item.budget | rupiah }}</span>
                      </div>
                    </div>

                    <div *ngIf="expandedStates[i]">
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.lm_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.lm_percentage)">
                            {{ item.lm_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_month | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ly_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.ly_percentage)">
                            {{ item.ly_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_year | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group last-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ty_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="value-text">{{ item.total_ytd | rupiah }}</span>
                          <span class="percentage-text" [class]="getPercentageClass(item.ty_percentage)">
                            {{ item.ty_percentage }}%
                          </span>
                          <span class="value-text">{{ item.this_year | rupiah }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>

              <div class="d-flex justify-content-center" *ngIf="!isLoading && revenueItem.length === 0">
                <div class="spinner-border text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid container-card">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-6">
          <h1 class="heading-1">Hotel List</h1>
        </div>
        <div class="col-12 col-md-6 col-lg-6">
          <div class="form-group group-input">
            <input type="text" class="form-control search-input" [(ngModel)]="searchTerm" (keyup)="onSearch($event)"
              placeholder="Type Hotel Name">
            <img src="assets/icons/search.png" alt="">
          </div>
        </div>
      </div>

      <div class="table-responsive my-3 d-none d-lg-block">
        <table class="table table-striped">

          <thead>
            <tr>
              <th class="sortable-header" (click)="onSort('hotel_name')">
                <span>Hotel Name</span>
                <i [class]="getSortIcon('hotel_name')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('room_available')">
                <span>Room Available</span>
                <i [class]="getSortIcon('room_available')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('room_sold')">
                <span>Room Sold</span>
                <i [class]="getSortIcon('room_sold')" class="sort-icon"></i>
              </th>
              <th class="text-end sortable-header" (click)="onSort('total_revenue')">
                <span>Total Revenue</span> <!--TW20250924-->
                <i [class]="getSortIcon('total_revenue')" class="sort-icon"></i>
              </th>
              <th class="text-end sortable-header" (click)="onSort('room_revenue')">
                <span>Room Revenue</span>
                <i [class]="getSortIcon('room_revenue')" class="sort-icon"></i>
              </th>
              <th class="text-end sortable-header" (click)="onSort('room_revenue')">
                <span>Room Rev Pctg</span> <!--TW20250924-->
                <i [class]="getSortIcon('room_rev_pctg')" class="sort-icon"></i>
              </th>
              <th class="text-end sortable-header" (click)="onSort('fb_revenue')">
                <span>F&B Rev</span>
                <i [class]="getSortIcon('fb_revenue')" class="sort-icon"></i>
              </th>
              <th class="text-end sortable-header" (click)="onSort('room_revenue')">
                <span>F&B Rev Pctg</span> <!--TW20250924-->
                <i [class]="getSortIcon('fb_rev_pctg')" class="sort-icon"></i>
              </th>
              <th class="text-end sortable-header" (click)="onSort('other_revenue')">
                <span>Other Rev</span>
                <i [class]="getSortIcon('other_revenue')" class="sort-icon"></i>
              </th>
              <th class="text-end sortable-header" (click)="onSort('other_revenue')">
                <span>Other Rev Pctg</span> <!--TW20250924-->
                <i [class]="getSortIcon('other_rev_pctg')" class="sort-icon"></i>
              </th>
               <!--TW20250924-->
              <!--<th class="text-end sortable-header" (click)="onSort('other_revenue')">
                <span>Mice Rev</span>
                <i [class]="getSortIcon('mice_revenue')" class="sort-icon"></i>
              </th>
              <th class="text-end sortable-header" (click)="onSort('other_revenue')">
                <span>Mice Rev Pctg</span> 
                <i [class]="getSortIcon('mice_rev_pctg')" class="sort-icon"></i>
              </th>-->
               <!--TW20250926-->
            </tr>
          </thead>
          <tbody *ngIf="!isLoading && displayedData.length > 0">
            <tr *ngFor="let item of displayedData">
              <td>
                <a [routerLink]="['/hotel/hotel-detail', item.id]">
                  {{ item.hotel_name }}
                </a>
              </td>
              <td class="text-center">{{ item.room_available | thousandSeparator }}</td> <!--TW20250924-->
              <td class="text-center">{{ item.room_sold | thousandSeparator }}</td> <!--TW20250924-->
              <td class="text-end">{{ item.total_revenue | rupiah }}</td> <!--TW20250924-->
              <td class="text-end">{{ item.room_revenue | rupiah }}</td>
              <td class="text-end">{{ item.room_rev_pctg }}%</td> <!--TW20250924-->
              <td class="text-end">{{ item.fb_revenue + item.mice_revenue | rupiah }}</td>
              <td class="text-end">{{ item.fb_rev_pctg + item.mice_rev_pctg }}%</td> <!--TW20250924-->
              <td class="text-end">{{ item.other_revenue | rupiah }}</td> 
              <td class="text-end">{{ item.other_rev_pctg }}%</td> <!--TW20250924-->
              <!--<td class="text-end">{{ item.mice_revenue | rupiah }}</td>
              <td class="text-end">{{ item.mice_rev_pctg }}%</td> --><!--TW20250924-->
            </tr>
          </tbody>
          <tbody *ngIf="isLoading">
            <tr>
              <td colspan="11" class="text-center"> <!--TW20250924-->
                <div class="spinner-border text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="!isLoading && displayedData.length === 0">  
            <tr>
              <td colspan="11" class="text-center">No data available</td> <!--TW20250924-->
            </tr>
          </tbody>
        </table>
      </div>

      <div class="my-4 d-block d-lg-none">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6" *ngFor="let item of displayedData; let i = index">
              <div class="card card-sm-custom my-3" [ngClass]="{'border bg-light': i % 2 !== 0}" role="button"
                tabindex="0" [routerLink]="['/hotel/hotel-detail', item.id]">

                <div class="card-body" *ngIf="!isLoading && displayedData.length > 0">
                  <div class="card-sm-header">
                    <h5>{{ item.hotel_name }}</h5>
                  </div>
                  
                  <!-- Room Available -->
                  <div class="row mb-2">
                    <div class="col-6 col-sm-5">
                      <div class="card-sm-title">Room Available</div>
                    </div>
                    <div class="col-6 col-sm-7">
                      <div class="card-sm-value">{{ item.room_available | thousandSeparator }}</div>
                    </div>
                  </div>
                  
                  <!-- Room Sold -->
                  <div class="row mb-2">
                    <div class="col-6 col-sm-5">
                      <div class="card-sm-title">Room Sold</div>
                    </div>
                    <div class="col-6 col-sm-7">
                      <div class="card-sm-value">{{ item.room_sold | thousandSeparator }}</div>
                    </div>
                  </div>
                  <!-- Total Revenue -->
                  <div class="row mb-2">
                    <div class="col-6 col-sm-5">
                      <div class="card-sm-title">Total Revenue</div> <!--TW20250924-->
                    </div>
                    <div class="col-6 col-sm-7">
                      <div class="card-sm-value">{{ item.total_revenue | rupiah }}</div> <!--TW20250924-->
                    </div>
                  </div>
                  <!-- Room Revenue -->
                  <div class="row mb-2">
                    <div class="col-6 col-sm-5">
                      <div class="card-sm-title">Total Revenue</div>
                    </div>
                    <div class="col-6 col-sm-7">
                      <div class="card-sm-value">{{ item.room_revenue | rupiah }}</div>
                    </div>
                  </div>
                  
                  <!-- Room Revenue Pctg -->
                  <div class="row mb-2">
                    <div class="col-6 col-sm-5">
                      <div class="card-sm-title">Room Revenue Pctg</div>
                    </div>
                    <div class="col-6 col-sm-7">
                      <div class="card-sm-value">{{ item.room_rev_pctg }}%</div>
                    </div>
                  </div>
                  
                  <!-- F&B Revenue -->
                  <div class="row mb-2">
                    <div class="col-6 col-sm-5">
                      <div class="card-sm-title">F&B Revenue</div>
                    </div>
                    <div class="col-6 col-sm-7">
                      <div class="card-sm-value">{{ item.fb_revenue + item.mice_revenue | rupiah }}</div>
                    </div>
                  </div>
                  
                  <!-- F&B Revenue Pctg -->
                  <div class="row mb-2">
                    <div class="col-6 col-sm-5">
                      <div class="card-sm-title">F&B Revenue Pctg</div>
                    </div>
                    <div class="col-6 col-sm-7">
                      <div class="card-sm-value">{{ item.fb_rev_pctg + item.mice_rev_pctg }}%</div>
                    </div>
                  </div>
                  
                  <!-- Other Revenue -->
                  <div class="row mb-2">
                    <div class="col-6 col-sm-5">
                      <div class="card-sm-title">Other Revenue</div>
                    </div>
                    <div class="col-6 col-sm-7">
                      <div class="card-sm-value">{{ item.other_revenue | rupiah }}</div>
                    </div>
                  </div>
                  
                  <!-- Other Revenue Pctg -->
                  <div class="row mb-2">
                    <div class="col-6 col-sm-5">
                      <div class="card-sm-title">Other Revenue Pctg</div>
                    </div>
                    <div class="col-6 col-sm-7">
                      <div class="card-sm-value">{{ item.other_rev_pctg }}%</div>
                    </div>
                  </div>
                  
                  <!-- Commented out Mice Revenue sections -->
                  <!--
                  <div class="row mb-2">
                    <div class="col-6 col-sm-5">
                      <div class="card-sm-title">Mice Revenue</div>
                    </div>
                    <div class="col-6 col-sm-7">
                      <div class="card-sm-value">{{ item.mice_revenue | rupiah }}</div>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-6 col-sm-5">
                      <div class="card-sm-title">Mice Rev Pctg</div>
                    </div>
                    <div class="col-6 col-sm-7">
                      <div class="card-sm-value">{{ item.mice_rev_pctg }}%</div>
                    </div>
                  </div>
                  -->
                </div>

                <div class="card-body d-flex justify-content-center" *ngIf="isLoading">
                  <div class="spinner-border text-success text-center" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-start mb-3">
          <div class="pagination-info">
            Displaying
            <span class="fw-bold">{{ displayRange.start | number }}</span> -
            <span class="fw-bold">{{ displayRange.end | number }}</span>
            out of
            <span class="fw-bold">{{ displayRange.total | number }}</span>
          </div>
        </div>
        <div
          class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-end justify-content-end page-pagination">
          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link first-page" href="javascript:void(0)" (click)="onFirstPage()" aria-label="First">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link prev-page" href="javascript:void(0)" (click)="onPrevPage()" aria-label="Previous">
                  <span aria-hidden="true">&lsaquo;</span>
                </a>
              </li>
              <li class="page-item" *ngFor="let page of pageNumbers"
                [class.active]="page === paginationConfig.currentPage">
                <a class="page-link" href="javascript:void(0)" (click)="onPageChange(page)">{{ page }}</a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link next-page" href="javascript:void(0)" (click)="onNextPage()" aria-label="Next">
                  <span aria-hidden="true">&rsaquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link last-page" href="javascript:void(0)" (click)="onLastPage()" aria-label="Last">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>

    </div>

  </div>
</section>
